export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';

